export * from "./interfaces/IndexProps.interface";
export * from "./interfaces/ReaderProps.interface";
export { BibloProvider } from "./hooks/Biblo.hook";
export { IndexScreen as BibloIndex } from "./screens/Index.screen";
export { ReaderScreen as BibloReader } from "./screens/Reader.screen";

/**
 * Function for importing files using a regex.
 * This has to be imported by the user, since it must happen in a local file
 * to allow detecting changes made in the imported files.
 */
export const bibloImporter = context => context.keys().reduce((obj, key) => ({
  ...obj,
  [key]: context(key)
}), {});
//# sourceMappingURL=index.js.map